import React, { useContext } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { AdminAuthContext } from "../AdminAuthContext";
import {
  FiArchive,
  FiBox,
  FiBriefcase,
  FiFileText,
  FiGlobe,
  FiLogOut,
  FiPercent,
  FiShoppingBag,
  FiTag,
  FiUsers,
} from "react-icons/fi";
import logo from "../assets/images/Valley Logo.png";
import "./AdminSidebar.css";

const menuGroups = [
  {
    label: "Operations",
    items: [
      { icon: FiShoppingBag, label: "Orders", path: "/admin/orders" },
      { icon: FiBriefcase, label: "Companies", path: "/admin/companies" },
    ],
  },
  {
    label: "Catalog",
    items: [
      { icon: FiBox, label: "Products", path: "/admin/products" },
      { icon: FiTag, label: "Brands", path: "/admin/brands" },
      { icon: FiGlobe, label: "Countries", path: "/admin/countries" },
      { icon: FiPercent, label: "Special fees", path: "/admin/fees" },
      { icon: FiArchive, label: "Batches", path: "/admin/batches" },
    ],
  },
  {
    label: "Administration",
    items: [
      { icon: FiUsers, label: "User accounts", path: "/admin/user-accounts" },
      { icon: FiFileText, label: "Content", path: "/admin/content" },
    ],
  },
];

export default function AdminSidebar() {
  const navigate = useNavigate();
  const { logout } = useContext(AdminAuthContext);

  const handleLogout = () => {
    logout();
    navigate("/admin-login", { replace: true });
  };

  return (
    <aside className="admin-sidebar" aria-label="Admin navigation">
      <div className="admin-sidebar__brand">
        <img src={logo} alt="Valley International Supply" />
        <span>ADMIN</span>
      </div>

      <nav className="admin-sidebar__nav">
        {menuGroups.map((group) => (
          <div className="admin-sidebar__group" key={group.label}>
            <p>{group.label}</p>
            {group.items.map(({ icon: Icon, label, path }) => (
              <NavLink
                to={path}
                key={path}
                className={({ isActive }) =>
                  `admin-sidebar__link ${isActive ? "is-active" : ""}`
                }
              >
                <Icon aria-hidden="true" />
                <span>{label}</span>
              </NavLink>
            ))}
          </div>
        ))}
      </nav>

      <div className="admin-sidebar__footer">
        <div className="admin-sidebar__profile">
          <span className="admin-sidebar__avatar">VA</span>
          <div>
            <strong>Valley Admin</strong>
            <span>Administrator</span>
          </div>
        </div>
        <button type="button" onClick={handleLogout} aria-label="Log out">
          <FiLogOut aria-hidden="true" />
        </button>
      </div>
    </aside>
  );
}
